import React from "react"
import { AuthRoles } from "components/auth"

export const VehicleRequirementsConfig = {
  auth: AuthRoles.admin,
  routes: [
    {
      path: `${process.env.PUBLIC_URL}/vehicle_requirements`,
      component: React.lazy(() => import("./VehicleRequirements")),
    },
  ],
}
